/**
 * Stripe keeps idempotency keys in its logs and dashboard, so the client's email
 * goes in hashed. It's hashed exactly as typed: Stripe rejects a repeated key sent
 * with a different email, so differently-cased addresses need different keys.
 */
export async function depositIdempotencyKey(
  listingId: string,
  serviceId: string,
  slotStart: string,
  email: string,
): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(email));
  const emailHash = Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
  return `${listingId}-${serviceId}-${slotStart}-${emailHash}`;
}
